module.exports = __webpack_public_path__ + "static/media/img-01.f3c4f3f4.png";